(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var styleModeKey = 'themevoStyleMode';

  function getStyleMode() {
    try {
      return window.localStorage.getItem(styleModeKey) || document.documentElement.getAttribute('data-style-mode') || 'dark';
    } catch (error) {
      return document.documentElement.getAttribute('data-style-mode') || 'dark';
    }
  }

  function setStyleMode(mode) {
    var nextMode = mode === 'light' ? 'light' : 'dark';

    document.documentElement.setAttribute('data-style-mode', nextMode);

    document.querySelectorAll('[data-style-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(nextMode === 'light'));
      button.setAttribute('aria-label', nextMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
    });

    document.querySelectorAll('[data-style-mode-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-style-mode-choice') === nextMode));
    });

    try {
      window.localStorage.setItem(styleModeKey, nextMode);
    } catch (error) {
      return;
    }
  }

  function getStyleModeSwitcher() {
    return document.querySelector('[data-style-mode-switch]');
  }

  function setStyleModePanel(open) {
    var switcher = getStyleModeSwitcher();

    if (!switcher) {
      return;
    }

    var trigger = switcher.querySelector('[data-style-mode-trigger]');
    var panel = switcher.querySelector('[data-style-mode-panel]');

    if (!trigger || !panel) {
      return;
    }

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  var langKey = 'themevoLang';
  var defaultLang = 'en';

  function getGoogTransCookieLang() {
    var match = document.cookie.match(/(?:^|;\s*)googtrans=\/en\/([a-zA-Z-]+)/);
    return match ? match[1] : null;
  }

  function getCurrentLang() {
    try {
      var stored = window.localStorage.getItem(langKey);

      if (stored) {
        return stored;
      }
    } catch (error) {
      // ignore storage errors
    }

    return getGoogTransCookieLang() || defaultLang;
  }

  function setGoogTransCookie(lang) {
    var host = window.location.hostname;
    var expired = 'googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

    document.cookie = expired;
    document.cookie = expired + ' domain=' + host + ';';

    if (lang && lang !== defaultLang) {
      document.cookie = 'googtrans=/en/' + lang + '; path=/;';
      document.cookie = 'googtrans=/en/' + lang + '; path=/; domain=' + host + ';';
    }
  }

  function getLangSwitcher() {
    return document.querySelector('[data-lang-switch]');
  }

  function setLangPanel(open) {
    var switcher = getLangSwitcher();

    if (!switcher) {
      return;
    }

    var trigger = switcher.querySelector('[data-lang-trigger]');
    var panel = switcher.querySelector('[data-lang-panel]');

    if (!trigger || !panel) {
      return;
    }

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  function syncLangChoices(lang) {
    document.querySelectorAll('[data-lang-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-lang-choice') === lang));
    });
  }

  function setLang(lang) {
    var nextLang = lang || defaultLang;
    var storedCookieLang = getGoogTransCookieLang();
    var alreadyActive = nextLang === defaultLang ? !storedCookieLang : storedCookieLang === nextLang;

    try {
      window.localStorage.setItem(langKey, nextLang);
    } catch (error) {
      // ignore storage errors
    }

    syncLangChoices(nextLang);

    if (alreadyActive) {
      return;
    }

    setGoogTransCookie(nextLang);
    window.location.reload();
  }

  function getInfoSwitcher() {
    return document.querySelector('[data-info-switch]');
  }

  function setInfoPanel(open) {
    var switcher = getInfoSwitcher();

    if (!switcher) {
      return;
    }

    var trigger = switcher.querySelector('[data-info-trigger]');
    var panel = switcher.querySelector('[data-info-panel]');

    if (!trigger || !panel) {
      return;
    }

    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  function getMenuToggle() {
    return document.querySelector('[data-menu-toggle], .header__menu-button');
  }

  function getMobileMenu() {
    return document.querySelector('[data-mobile-menu]');
  }

  function getMenuDrawer() {
    return document.querySelector('[data-menu-drawer]');
  }

  function getMenuScrim() {
    return document.querySelector('.mobile-menu-scrim');
  }

  function getDesktopCategoryMenu() {
    return document.querySelector('[data-desktop-category-menu]');
  }

  function isDesktopMenu() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function isPointInRect(x, y, rect, padding) {
    return (
      x >= rect.left - padding &&
      x <= rect.right + padding &&
      y >= rect.top - padding &&
      y <= rect.bottom + padding
    );
  }

  function isPointInDesktopMenuArea(x, y) {
    var menuToggle = getMenuToggle();
    var mobileMenu = getMobileMenu();
    var menuDrawer = getMenuDrawer();

    if (!menuToggle || !mobileMenu) {
      return false;
    }

    var toggleRect = menuToggle.getBoundingClientRect();
    var menuRect = mobileMenu.getBoundingClientRect();
    var drawerRect = menuDrawer ? menuDrawer.getBoundingClientRect() : null;

    if (
      isPointInRect(x, y, toggleRect, 14) ||
      isPointInRect(x, y, menuRect, 8) ||
      (drawerRect && isPointInRect(x, y, drawerRect, 12))
    ) {
      return true;
    }

    var bridgeTop = Math.min(toggleRect.bottom, menuRect.top) - 18;
    var bridgeBottom = Math.max(toggleRect.bottom, menuRect.top) + 34;
    var bridgeLeft = Math.min(toggleRect.left, menuRect.left) - 34;
    var bridgeRight = Math.max(toggleRect.right, menuRect.right) + 34;

    return x >= bridgeLeft && x <= bridgeRight && y >= bridgeTop && y <= bridgeBottom;
  }

  var desktopMenuCloseTimer = null;
  var desktopPointer = { x: 0, y: 0 };
  var desktopCategoryCloseTimer = null;
  var desktopCategoryPointer = { x: 0, y: 0 };

  function clearDesktopMenuCloseTimer() {
    if (desktopMenuCloseTimer) {
      window.clearTimeout(desktopMenuCloseTimer);
      desktopMenuCloseTimer = null;
    }
  }

  function scheduleDesktopMenuClose() {
    if (desktopMenuCloseTimer) {
      return;
    }

    desktopMenuCloseTimer = window.setTimeout(function () {
      desktopMenuCloseTimer = null;

      if (!isPointInDesktopMenuArea(desktopPointer.x, desktopPointer.y)) {
        setMobileMenu(false);
      }
    }, 140);
  }

  function clearDesktopCategoryCloseTimer() {
    if (desktopCategoryCloseTimer) {
      window.clearTimeout(desktopCategoryCloseTimer);
      desktopCategoryCloseTimer = null;
    }
  }

  function isPointInDesktopCategoryArea(x, y) {
    var menu = getDesktopCategoryMenu();

    if (!menu) {
      return false;
    }

    var toggle = menu.querySelector('[data-desktop-category-toggle]');
    var panel = menu.querySelector('[data-desktop-category-panel]');

    if (!toggle || !panel) {
      return false;
    }

    var toggleRect = toggle.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();

    if (isPointInRect(x, y, toggleRect, 18) || isPointInRect(x, y, panelRect, 10)) {
      return true;
    }

    var bridgeTop = Math.min(toggleRect.bottom, panelRect.top) - 8;
    var bridgeBottom = Math.max(toggleRect.bottom, panelRect.top) + 36;
    var bridgeLeft = Math.min(toggleRect.left, panelRect.left) - 44;
    var bridgeRight = Math.max(toggleRect.right, panelRect.right) + 44;

    return x >= bridgeLeft && x <= bridgeRight && y >= bridgeTop && y <= bridgeBottom;
  }

  function setDesktopCategoryMenu(isOpen) {
    var menu = getDesktopCategoryMenu();

    if (!menu) {
      return;
    }

    var toggle = menu.querySelector('[data-desktop-category-toggle]');

    if (isOpen) {
      clearDesktopCategoryCloseTimer();
    }

    menu.classList.toggle('is-open', isOpen);

    if (toggle) {
      toggle.setAttribute('aria-expanded', String(isOpen));
    }
  }

  function scheduleDesktopCategoryClose() {
    if (desktopCategoryCloseTimer) {
      return;
    }

    desktopCategoryCloseTimer = window.setTimeout(function () {
      desktopCategoryCloseTimer = null;

      if (!isPointInDesktopCategoryArea(desktopCategoryPointer.x, desktopCategoryPointer.y)) {
        setDesktopCategoryMenu(false);
      }
    }, 180);
  }

  function setMobileMenu(isOpen) {
    var mobileMenu = getMobileMenu();
    var menuToggle = getMenuToggle();
    var menuDrawer = getMenuDrawer();
    var menuScrim = getMenuScrim();

    if (!mobileMenu && !menuDrawer) {
      return;
    }

    if (isOpen) {
      clearDesktopMenuCloseTimer();
    }

    if (menuDrawer) {
      menuDrawer.open = isOpen;
    }

    if (mobileMenu) {
      mobileMenu.classList.toggle('is-open', isOpen);
    }

    document.body.classList.toggle('mobile-menu-open', isOpen);

    if (menuScrim) {
      menuScrim.classList.toggle('is-open', isOpen);
    }

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    }

    if (isOpen && !isDesktopMenu()) {
      document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (submenuToggle) {
        var submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));

        submenuToggle.setAttribute('aria-expanded', 'true');

        if (submenu) {
          submenu.removeAttribute('hidden');
        }
      });
    }
  }

  document.addEventListener('click', function (event) {
    var liveDemoLink = event.target.closest('[data-live-demo-link]');

    if (!liveDemoLink) {
      return;
    }

    var demoUrl = liveDemoLink.getAttribute('href');

    if (!demoUrl || demoUrl.charAt(0) === '#') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var openedWindow = window.open(demoUrl, '_blank');

    if (openedWindow) {
      openedWindow.opener = null;
    } else {
      window.location.href = demoUrl;
    }
  }, true);

  document.addEventListener('click', function (event) {
    var styleToggle = event.target.closest('[data-style-toggle]');
    var styleModeTrigger = event.target.closest('[data-style-mode-trigger]');
    var styleModeChoice = event.target.closest('[data-style-mode-choice]');
    var styleModeClose = event.target.closest('[data-style-mode-close]');
    var langTrigger = event.target.closest('[data-lang-trigger]');
    var langChoice = event.target.closest('[data-lang-choice]');
    var langClose = event.target.closest('[data-lang-close]');
    var infoTrigger = event.target.closest('[data-info-trigger]');
    var infoClose = event.target.closest('[data-info-close]');
    var menuToggle = event.target.closest('[data-menu-toggle]');
    var menuCloser = event.target.closest('[data-menu-close]');
    var submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    var desktopCategoryToggle = event.target.closest('[data-desktop-category-toggle]');
    var menuLink = event.target.closest('a[href^="#"], [data-mobile-menu] a');

    if (styleModeTrigger) {
      var stylePanel = getStyleModeSwitcher() ? getStyleModeSwitcher().querySelector('[data-style-mode-panel]') : null;
      event.preventDefault();
      setStyleModePanel(stylePanel ? stylePanel.hidden : true);
      return;
    }

    if (styleModeChoice) {
      event.preventDefault();
      setStyleMode(styleModeChoice.getAttribute('data-style-mode-choice'));
      setStyleModePanel(false);
      return;
    }

    if (styleModeClose) {
      event.preventDefault();
      setStyleModePanel(false);
      return;
    }

    if (langTrigger) {
      var langSwitcher = getLangSwitcher();
      var langPanel = langSwitcher ? langSwitcher.querySelector('[data-lang-panel]') : null;
      event.preventDefault();
      setLangPanel(langPanel ? langPanel.hidden : true);
      return;
    }

    if (langChoice) {
      event.preventDefault();
      setLang(langChoice.getAttribute('data-lang-choice'));
      setLangPanel(false);
      return;
    }

    if (langClose) {
      event.preventDefault();
      setLangPanel(false);
      return;
    }

    if (infoTrigger) {
      var infoSwitcher = getInfoSwitcher();
      var infoPanel = infoSwitcher ? infoSwitcher.querySelector('[data-info-panel]') : null;
      event.preventDefault();
      setInfoPanel(infoPanel ? infoPanel.hidden : true);
      return;
    }

    if (infoClose) {
      event.preventDefault();
      setInfoPanel(false);
      return;
    }

    if (styleToggle) {
      event.preventDefault();
      setStyleMode(getStyleMode() === 'light' ? 'dark' : 'light');
      return;
    }

    if (desktopCategoryToggle && isDesktopMenu()) {
      event.preventDefault();
      var desktopCategoryMenu = getDesktopCategoryMenu();
      var isCategoryOpen = desktopCategoryMenu && desktopCategoryMenu.classList.contains('is-open');
      setDesktopCategoryMenu(!isCategoryOpen);
      return;
    }

    if (menuToggle) {
      var mobileMenu = getMobileMenu();
      event.preventDefault();

      if (isDesktopMenu()) {
        setMobileMenu(true);
        return;
      }

      setMobileMenu(!(mobileMenu && mobileMenu.classList.contains('is-open')));
      return;
    }

    if (menuCloser) {
      event.preventDefault();
      setMobileMenu(false);
      return;
    }

    if (submenuToggle) {
      var submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));

      if (submenu) {
        var isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', String(!isOpen));

        if (isOpen) {
          submenu.setAttribute('hidden', 'hidden');
        } else {
          submenu.removeAttribute('hidden');
        }
      }

      return;
    }

    if (menuLink) {
      var openMenu = getMobileMenu();

      if (openMenu && openMenu.classList.contains('is-open')) {
        setMobileMenu(false);
      }
    }

    if (!event.target.closest('[data-style-mode-switch]')) {
      setStyleModePanel(false);
    }

    if (!event.target.closest('[data-lang-switch]')) {
      setLangPanel(false);
    }

    if (!event.target.closest('[data-info-switch]')) {
      setInfoPanel(false);
    }

    if (isDesktopMenu() && !event.target.closest('[data-desktop-category-menu]')) {
      setDesktopCategoryMenu(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMobileMenu(false);
      setDesktopCategoryMenu(false);
      setStyleModePanel(false);
      setLangPanel(false);
      setInfoPanel(false);
    }
  });

  document.addEventListener('mouseover', function (event) {
    if (!isDesktopMenu()) {
      return;
    }

    if (event.target.closest('[data-desktop-category-menu]')) {
      setDesktopCategoryMenu(true);
      return;
    }

    if (event.target.closest('[data-menu-toggle], [data-menu-drawer]')) {
      setMobileMenu(true);
    }
  });

  document.addEventListener('mousemove', function (event) {
    var menuDrawer = getMenuDrawer();

    if (!isDesktopMenu() || !menuDrawer || !menuDrawer.open) {
      return;
    }

    desktopPointer.x = event.clientX;
    desktopPointer.y = event.clientY;

    if (isPointInDesktopMenuArea(event.clientX, event.clientY)) {
      clearDesktopMenuCloseTimer();
      return;
    }

    scheduleDesktopMenuClose();
  });

  document.addEventListener('mousemove', function (event) {
    var categoryMenu = getDesktopCategoryMenu();

    if (!isDesktopMenu() || !categoryMenu || !categoryMenu.classList.contains('is-open')) {
      return;
    }

    desktopCategoryPointer.x = event.clientX;
    desktopCategoryPointer.y = event.clientY;

    if (isPointInDesktopCategoryArea(event.clientX, event.clientY)) {
      clearDesktopCategoryCloseTimer();
      return;
    }

    scheduleDesktopCategoryClose();
  });

  window.addEventListener('resize', function () {
    if (!isDesktopMenu()) {
      setMobileMenu(false);
      setDesktopCategoryMenu(false);
    }
  });

  document.addEventListener('toggle', function (event) {
    if (!event.target.matches || !event.target.matches('[data-menu-drawer]')) {
      return;
    }

    var menuDrawer = event.target;
    var drawerMenu = menuDrawer.querySelector('[data-mobile-menu]');
    var drawerScrim = menuDrawer.querySelector('.mobile-menu-scrim');
    var isOpen = menuDrawer.open;

    if (drawerMenu) {
      drawerMenu.classList.toggle('is-open', isOpen);
    }

    if (drawerScrim) {
      drawerScrim.classList.toggle('is-open', isOpen);
    }

    document.body.classList.toggle('mobile-menu-open', isOpen);
  }, true);

  setStyleMode(getStyleMode());
  syncLangChoices(getCurrentLang());

  var collectionGrid = document.querySelector('[data-collection-product-grid]');
  var collectionViewButtons = document.querySelectorAll('[data-collection-view]');

  if (collectionGrid && collectionViewButtons.length) {
    var storedCollectionView = 'grid';

    try {
      storedCollectionView = window.localStorage.getItem('themevoCollectionView') || 'grid';
    } catch (error) {
      storedCollectionView = 'grid';
    }

    function setCollectionView(view) {
      var isListView = view === 'list';

      collectionGrid.classList.toggle('is-list-view', isListView);

      collectionViewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-collection-view') === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      try {
        window.localStorage.setItem('themevoCollectionView', view);
      } catch (error) {
        return;
      }
    }

    collectionViewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setCollectionView(button.getAttribute('data-collection-view') || 'grid');
      });
    });

    setCollectionView(storedCollectionView);
  }

  document.querySelectorAll('[data-template-toolbar]').forEach(function (toolbar) {
    var templateSection = toolbar.closest('.featured-templates');
    var sortButtons = toolbar.querySelectorAll('[data-template-sort]');
    var viewButtons = toolbar.querySelectorAll('[data-template-view]');
    var countElement = toolbar.querySelector('[data-template-sort-count]');
    var sortDetails = toolbar.querySelector('[data-template-sort-details]');

    if (!templateSection) {
      return;
    }

    function getTemplateGrids() {
      return Array.prototype.slice.call(templateSection.querySelectorAll('[data-template-grid]'));
    }

    function getActiveTemplateGrid() {
      return templateSection.querySelector('.template-tab-panel.is-active [data-template-grid]') || templateSection.querySelector('[data-template-grid]');
    }

    function getSortCards(grid) {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-sort-card]'));
    }

    function prepareSortCards() {
      getTemplateGrids().forEach(function (grid) {
        getSortCards(grid).forEach(function (card, index) {
          if (!card.hasAttribute('data-sort-index')) {
            card.setAttribute('data-sort-index', String(index));
          }
        });
      });
    }

    function getNumber(card, attribute) {
      return Number(card.getAttribute(attribute)) || 0;
    }

    function sortGrid(grid, mode) {
      var cards = getSortCards(grid);

      cards.sort(function (cardA, cardB) {
        var originalA = getNumber(cardA, 'data-sort-index');
        var originalB = getNumber(cardB, 'data-sort-index');
        var titleA = (cardA.getAttribute('data-sort-title') || '').toLowerCase();
        var titleB = (cardB.getAttribute('data-sort-title') || '').toLowerCase();
        var priceA = getNumber(cardA, 'data-sort-price');
        var priceB = getNumber(cardB, 'data-sort-price');
        var dateA = getNumber(cardA, 'data-sort-date');
        var dateB = getNumber(cardB, 'data-sort-date');
        var salesA = getNumber(cardA, 'data-sort-sales');
        var salesB = getNumber(cardB, 'data-sort-sales');

        if (mode === 'title-asc') {
          return titleA.localeCompare(titleB);
        }

        if (mode === 'title-desc') {
          return titleB.localeCompare(titleA);
        }

        if (mode === 'price-asc') {
          return priceA - priceB;
        }

        if (mode === 'price-desc') {
          return priceB - priceA;
        }

        if (mode === 'date-asc') {
          return dateA - dateB || originalA - originalB;
        }

        if (mode === 'date-desc') {
          return dateB - dateA || originalA - originalB;
        }

        if (mode === 'selling') {
          return salesB - salesA || originalA - originalB;
        }

        return originalA - originalB;
      });

      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function updateTemplateCount() {
      var activeGrid = getActiveTemplateGrid();

      if (activeGrid && countElement) {
        countElement.textContent = String(getSortCards(activeGrid).length);
      }
    }

    function setTemplateSort(mode, selectedButton) {
      getTemplateGrids().forEach(function (grid) {
        sortGrid(grid, mode);
      });

      sortButtons.forEach(function (button) {
        var isActive = button === selectedButton;
        var check = button.querySelector('.collection-sort__check');

        button.classList.toggle('is-active', isActive);
        button.toggleAttribute('aria-current', isActive);

        if (check) {
          check.textContent = isActive ? String.fromCharCode(10003) : '';
        }
      });

      if (sortDetails) {
        sortDetails.open = false;
      }

      updateTemplateCount();
    }

    function setTemplateView(view) {
      var isListView = view === 'list';

      getTemplateGrids().forEach(function (grid) {
        grid.classList.toggle('is-list-view', isListView);
      });

      viewButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-template-view') === view;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    prepareSortCards();
    updateTemplateCount();

    sortButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTemplateSort(button.getAttribute('data-template-sort') || 'featured', button);
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setTemplateView(button.getAttribute('data-template-view') || 'grid');
      });
    });

    templateSection.querySelectorAll('[data-template-tab]').forEach(function (tabButton) {
      tabButton.addEventListener('click', function () {
        window.setTimeout(updateTemplateCount, 0);
      });
    });
  });

  document.querySelectorAll('[data-ad-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-ad-slide]');
    var dots = slider.querySelectorAll('[data-ad-dot]');
    var prevButton = slider.querySelector('[data-ad-prev]');
    var nextButton = slider.querySelector('[data-ad-next]');
    var currentIndex = 0;
    var timer = null;
    var interval = Number(slider.getAttribute('data-interval')) || 4000;
    var shouldAutoplay = slider.getAttribute('data-autoplay') === 'true';
    var remaining = interval;
    var startedAt = 0;

    if (slides.length <= 1) {
      return;
    }

    slider.style.setProperty('--ad-progress-duration', interval + 'ms');

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function clearProgress() {
      dots.forEach(function (dot) {
        dot.classList.remove('is-ticking', 'is-paused');
      });
    }

    function restartProgress() {
      clearProgress();

      if (!shouldAutoplay || !dots[currentIndex]) {
        return;
      }

      slider.style.setProperty('--ad-progress-duration', interval + 'ms');
      void dots[currentIndex].offsetWidth;
      dots[currentIndex].classList.add('is-ticking');
    }

    function pauseProgress() {
      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-paused');
      }
    }

    function resumeProgress() {
      if (dots[currentIndex]) {
        dots[currentIndex].classList.remove('is-paused');
      }
    }

    function showSlide(nextIndex) {
      currentIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        var isActive = index === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach(function (dot, index) {
        var isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    function scheduleAutoplay(delay) {
      clearTimer();

      if (!shouldAutoplay) {
        return;
      }

      startedAt = Date.now();
      remaining = delay;

      timer = window.setTimeout(function () {
        showSlide(currentIndex + 1);
        startAutoplay(true);
      }, delay);
    }

    function stopAutoplay(resetProgress) {
      if (!shouldAutoplay) {
        clearProgress();
        return;
      }

      if (timer) {
        remaining = Math.max(0, remaining - (Date.now() - startedAt));
      }

      clearTimer();

      if (resetProgress) {
        remaining = interval;
        clearProgress();
      } else {
        pauseProgress();
      }
    }

    function startAutoplay(resetCycle) {
      if (!shouldAutoplay) {
        clearProgress();
        return;
      }

      if (resetCycle) {
        remaining = interval;
        restartProgress();
        scheduleAutoplay(interval);
        return;
      }

      if (timer) {
        return;
      }

      if (remaining <= 0 || remaining > interval) {
        remaining = interval;
        restartProgress();
      } else {
        resumeProgress();
      }

      scheduleAutoplay(remaining);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        showSlide(currentIndex - 1);
        startAutoplay(true);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentIndex + 1);
        startAutoplay(true);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        showSlide(index);
        startAutoplay(true);
      });
    });

    /* Hover/focus must not pause or reset the 4-second autoplay timer. */

    showSlide(0);
    startAutoplay(true);
  });

  document.querySelectorAll('[data-nav-dropdown-item]').forEach(function (dropdownItem) {
    var dropdownToggle = dropdownItem.querySelector('[data-nav-dropdown-toggle]');

    if (!dropdownToggle) {
      return;
    }

    dropdownToggle.addEventListener('click', function () {
      var isOpen = dropdownItem.classList.toggle('is-open');
      dropdownToggle.setAttribute('aria-expanded', String(isOpen));
    });

    dropdownItem.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!dropdownItem.contains(event.target)) {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });

    dropdownToggle.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        dropdownItem.classList.remove('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownToggle.focus();
      }
    });
  });

  var mainImage = document.querySelector('[data-product-main-image]');
  var thumbnails = document.querySelectorAll('[data-product-thumbnail]');

  if (mainImage && thumbnails.length) {
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var nextImage = thumbnail.getAttribute('data-image');
        if (nextImage) {
          mainImage.setAttribute('src', nextImage);
        }
      });
    });
  }

  document.querySelectorAll('[data-template-tabs]').forEach(function (tabs) {
    var tabButtons = tabs.querySelectorAll('[data-template-tab]');
    var tabPanels = tabs.querySelectorAll('[data-template-panel]');

    function activateTab(nextButton, shouldScroll) {
      var targetPanelId = nextButton.getAttribute('aria-controls');

      tabButtons.forEach(function (button) {
        var isActive = button === nextButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach(function (panel) {
        var isActive = panel.id === targetPanelId;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });

      if (shouldScroll) {
        var templateSection = tabs.closest('#featured-templates');
        if (templateSection) {
          templateSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    function activateCategoryFromHash() {
      if (window.location.hash.indexOf('#category-') !== 0 && window.location.hash.indexOf('#template-') !== 0) {
        return;
      }

      var category = window.location.hash.replace('#category-', '').replace('#template-', '');
      var nextButton = tabs.querySelector('[data-template-tab][data-template-category="' + category + '"]');

      if (nextButton) {
        activateTab(nextButton, true);
      }
    }

    tabButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activateTab(button);
      });

      button.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = index + 1 >= tabButtons.length ? 0 : index + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = index - 1 < 0 ? tabButtons.length - 1 : index - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabButtons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabButtons[nextIndex].focus();
        activateTab(tabButtons[nextIndex]);
      });
    });

    activateCategoryFromHash();
    window.addEventListener('hashchange', activateCategoryFromHash);
  });

  // ---- Floating header: stays pinned to the top at all times, condenses on scroll ----
  (function () {
    var header = document.querySelector('[data-sticky-header]');

    if (!header) {
      return;
    }

    var ticking = false;
    var scrolledThreshold = 24;

    function updateHeader() {
      var currentScrollY = window.scrollY || 0;

      header.classList.toggle('is-header-scrolled', currentScrollY > scrolledThreshold);

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  })();

  // ---- Featured templates grid: reveal cards from alternating sides on scroll ----
  (function () {
    var cards = document.querySelectorAll('.featured-templates .product-grid .product-card');

    if (!cards.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      cards.forEach(function (card) {
        card.classList.add('is-revealed');
      });
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-revealed', entry.isIntersecting);
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -8% 0px'
    });

    cards.forEach(function (card) {
      revealObserver.observe(card);
    });
  })();

  // ---- Premium homepage section reveal ----
  (function () {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var selectors = [
      '.trust-badges',
      '.featured-templates',
      '.theme-bundle',
      '.promo-banner-section',
      '.themevo-pro',
      '.faq-section'
    ];
    var sections = document.querySelectorAll(selectors.join(','));
    if (!sections.length) return;

    sections.forEach(function (section) {
      section.setAttribute('data-themevo-reveal', '');
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') {
      sections.forEach(function (section) { section.classList.add('is-themevo-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-themevo-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

    sections.forEach(function (section) { observer.observe(section); });
  })();

  // ---- Floating particle dots: any [data-particle-field] container (featured templates edges, collection hero) ----
  (function () {
    var containers = document.querySelectorAll('[data-particle-field]');

    if (!containers.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      return;
    }

    var particleColors = [
      'rgba(255, 255, 255, .82)',
      'rgba(228, 236, 231, .68)',
      'rgba(96, 238, 169, .78)',
      'rgba(68, 218, 145, .66)'
    ];
    var greenParticleColors = particleColors;
    var defaultParticleCount = 20;

    containers.forEach(function (container) {
      var requestedCount = parseInt(container.getAttribute('data-particle-count'), 10);
      var particleCount = isNaN(requestedCount) ? defaultParticleCount : requestedCount;
      var containerColors = container.hasAttribute('data-particle-green') ? greenParticleColors : particleColors;

      for (var i = 0; i < particleCount; i++) {
        var particle = document.createElement('span');
        particle.className = 'ft-particle';
        particle.setAttribute('aria-hidden', 'true');

        var isSparseSideField = container.hasAttribute('data-particle-sparse');
        var size = isSparseSideField
          ? (Math.random() * 0.95 + 0.75).toFixed(1)
          : (Math.random() * 3.2 + 1.8).toFixed(1);
        var startX = (Math.random() * 80 + 10).toFixed(1);
        var startY = isSparseSideField
          ? (((i + Math.random()) / particleCount) * 96 + 2).toFixed(1)
          : (Math.random() * 92 + 4).toFixed(1);
        var dx = isSparseSideField
          ? (Math.random() * 12 - 6).toFixed(0)
          : (Math.random() * 34 - 17).toFixed(0);
        var dy = isSparseSideField
          ? (-(Math.random() * 26 + 14)).toFixed(0)
          : (-(Math.random() * 55 + 25)).toFixed(0);
        var duration = isSparseSideField
          ? (Math.random() * 3.5 + 6.0).toFixed(1)
          : (Math.random() * 6 + 7).toFixed(1);
        var delay = (Math.random() * -16).toFixed(1);
        var opacity = isSparseSideField
          ? (Math.random() * 0.20 + 0.58).toFixed(2)
          : (Math.random() * 0.35 + 0.35).toFixed(2);
        var color = containerColors[Math.floor(Math.random() * containerColors.length)];

        particle.style.setProperty('--ft-size', size + 'px');
        particle.style.setProperty('--ft-x', startX + '%');
        particle.style.setProperty('--ft-y', startY + '%');
        particle.style.setProperty('--ft-dx', dx + 'px');
        particle.style.setProperty('--ft-dy', dy + 'px');
        particle.style.setProperty('--ft-duration', duration + 's');
        particle.style.setProperty('--ft-delay', delay + 's');
        particle.style.setProperty('--ft-opacity', opacity);
        particle.style.setProperty('--ft-color', color);

        container.appendChild(particle);
      }
    });
  })();

  // ---- Mobile-only "back to top" floating button ----
  (function () {
    var scrollButton = document.querySelector('[data-scroll-to-top]');

    if (!scrollButton) {
      return;
    }

    var visibleThreshold = 280;
    var ticking = false;

    function updateScrollButton() {
      var currentScrollY = window.scrollY || window.pageYOffset || 0;

      scrollButton.classList.toggle('is-visible', currentScrollY > visibleThreshold);

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollButton);
        ticking = true;
      }
    }, { passive: true });

    scrollButton.addEventListener('click', function () {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } catch (error) {
        window.scrollTo(0, 0);
      }
    });

    updateScrollButton();
  })();


  // ---- View Theme product details modal ----
  (function () {
    var activeModal = null;
    var lastTrigger = null;

    function portalModal(modal) {
      if (!modal) return null;
      // Product cards often live inside sliders/grids that use transform or overflow.
      // A position:fixed modal inside such an ancestor is clipped and positioned
      // relative to that card. Move every details modal to <body> so it always
      // covers the full viewport on desktop and mobile.
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      return modal;
    }

    function portalAllModals() {
      document.querySelectorAll('[data-theme-details-modal]').forEach(function (modal) {
        portalModal(modal);
      });
    }

    function findModal(handle) {
      var modal = document.querySelector('[data-theme-details-modal="' + handle + '"]');
      return portalModal(modal);
    }

    function normalizeThemeKey(value) {
      return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function findModalByTitleKey(key) {
      var normalizedKey = normalizeThemeKey(key);
      if (!normalizedKey) return null;
      var modals = document.querySelectorAll('[data-theme-details-modal][data-theme-title]');
      for (var i = 0; i < modals.length; i += 1) {
        var modal = modals[i];
        var title = normalizeThemeKey(modal.getAttribute('data-theme-title'));
        if (title.indexOf(normalizedKey) !== -1) {
          return portalModal(modal);
        }
      }
      return null;
    }

    function closeModal(restoreFocus) {
      if (!activeModal) return;

      var viewer = activeModal.querySelector('[data-theme-image-viewer]');
      if (viewer && viewer.open) viewer.close();
      activeModal.hidden = true;
      activeModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('theme-details-open');
      document.documentElement.classList.remove('theme-details-open');

      if (restoreFocus !== false && lastTrigger && typeof lastTrigger.focus === 'function') {
        try { lastTrigger.focus({ preventScroll: true }); } catch (error) {}
      }

      activeModal = null;
      lastTrigger = null;
    }

    function openModal(handle, trigger) {
      var modal = findModal(handle);
      if (!modal) return;

      // Only one product-details modal may be open at a time.
      if (activeModal && activeModal !== modal) {
        closeModal(false);
      }

      activeModal = modal;
      lastTrigger = trigger || null;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('theme-details-open');
      document.documentElement.classList.add('theme-details-open');

      // Always start the modal at the top, even if it was previously scrolled.
      var dialog = modal.querySelector('.theme-details-modal__dialog');
      if (dialog) dialog.scrollTop = 0;

      var close = modal.querySelector('.theme-details-modal__close');
      if (close) {
        window.setTimeout(function () {
          if (activeModal === modal && !modal.hidden) close.focus();
        }, 10);
      }
    }

    function updatePreview(modal, thumb) {
      var mainImage = modal.querySelector('[data-theme-details-main-image]');
      if (!mainImage || !thumb) return;
      mainImage.src = thumb.getAttribute('data-image');
      mainImage.alt = thumb.getAttribute('data-image-alt') || '';
      mainImage.dataset.zoomImage = thumb.getAttribute('data-zoom-image') || mainImage.src;
      modal.querySelector('[data-theme-image-open]').style.setProperty('--theme-preview-ratio', thumb.getAttribute('data-image-ratio') || '1.5');
      var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-theme-details-thumb]'));
      thumbs.forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
        item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
      });
      var count = modal.querySelector('[data-theme-image-count]');
      if (count) count.textContent = (thumbs.indexOf(thumb) + 1) + ' / ' + thumbs.length;
      // Scroll only the thumbnail strip, never the product page.
      var strip = thumb.parentElement;
      if (thumb.offsetLeft < strip.scrollLeft) strip.scrollLeft = thumb.offsetLeft;
      else if (thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = thumb.offsetLeft + thumb.offsetWidth - strip.clientWidth;
      var viewer = modal.querySelector('[data-theme-image-viewer]');
      if (viewer && viewer.open) updateEnlargedPreview(modal);
    }

    function updateEnlargedPreview(modal) {
      var source = modal.querySelector('[data-theme-details-main-image]');
      var image = modal.querySelector('[data-theme-image-expanded]');
      image.src = source.dataset.zoomImage || source.src;
      image.alt = source.alt;
      modal.querySelector('.theme-image-viewer__canvas').scrollTop = 0;
    }

    function stepPreview(modal, step) {
      var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-theme-details-thumb]'));
      if (!thumbs.length) return;
      var index = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      updatePreview(modal, thumbs[(index + step + thumbs.length) % thumbs.length]);
    }

    document.addEventListener('themevo:cart:before-open', function (event) {
      if (!activeModal) return;
      // Return to the theme card after the cart closes, not to its hidden buy button.
      if (event.detail && lastTrigger) event.detail.returnFocus = lastTrigger;
      closeModal(false);
    });

    // Hoist modals as soon as this script runs and again after load. This also
    // keeps Shopify theme-editor previews stable when product cards sit in
    // transformed carousels.
    portalAllModals();
    document.addEventListener('DOMContentLoaded', portalAllModals, { once: true });
    document.addEventListener('shopify:section:load', portalAllModals);

    document.addEventListener('click', function (event) {
      var titleOpener = event.target.closest('[data-theme-title-open]');
      if (titleOpener) {
        event.preventDefault();
        event.stopPropagation();
        var titleModal = findModalByTitleKey(titleOpener.getAttribute('data-theme-title-open'));
        if (titleModal) {
          openModal(titleModal.getAttribute('data-theme-details-modal'), titleOpener);
        }
        return;
      }

      var opener = event.target.closest('[data-theme-details-open]');
      if (opener) {
        event.preventDefault();
        event.stopPropagation();
        openModal(opener.getAttribute('data-theme-details-open'), opener);
        return;
      }

      var closer = event.target.closest('[data-theme-details-close]');
      if (closer) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
        return;
      }

      var galleryAction = event.target.closest('[data-theme-details-thumb], [data-theme-image-open], [data-theme-image-close], [data-theme-image-step]');
      if (galleryAction) {
        var modal = galleryAction.closest('[data-theme-details-modal]');
        if (!modal) return;
        event.preventDefault();
        if (galleryAction.hasAttribute('data-theme-details-thumb')) updatePreview(modal, galleryAction);
        else if (galleryAction.hasAttribute('data-theme-image-step')) stepPreview(modal, Number(galleryAction.dataset.themeImageStep));
        else if (galleryAction.hasAttribute('data-theme-image-open')) {
          updateEnlargedPreview(modal);
          modal.querySelector('[data-theme-image-viewer]').showModal();
        } else modal.querySelector('[data-theme-image-viewer]').close();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!activeModal) return;
      var viewer = activeModal.querySelector('[data-theme-image-viewer]');
      if (viewer && viewer.open) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          stepPreview(activeModal, event.key === 'ArrowRight' ? 1 : -1);
        }
        return; // Native dialog handles Escape and focus without closing the product page.
      }
      // Live previews are separate overlays above the theme details page.
      if (document.querySelector('[class*="demo-overlay"]:not([hidden])[aria-hidden="false"]')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'Tab') {
        var controls = Array.prototype.filter.call(activeModal.querySelectorAll(
          'button:not([disabled]), a[href], select:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, [tabindex="0"]'
        ), function (control) { return control.getClientRects().length > 0; });
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !activeModal.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !activeModal.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  })();

})();
